import Vue from "vue";
import App from "./App.vue";
import $ from 'jquery';
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import moment from 'moment';
import iziToast from 'izitoast'
import 'izitoast/dist/css/iziToast.min.css'
import 'izitoast/dist/js/iziToast.min.js'
import '@/assets/css/style.css'
import firebase from './firebase/init'
import firebaseapp, { PROJECT_ID, URL_CLOUD_FUNCTIONS } from './firebase/init'
import Axios from "axios";
import { Store } from "vuex";

Vue.config.productionTip = false;
Vue.use(moment as any)
Vue.use(iziToast as any)

export const db = firebase.firestore()
export const storage = firebase.storage()
export const storageRef = firebase.storage().ref()
export const auth = firebase.auth()

let userType = store.state.user.type
let userSubType = store.state.user.subType

function validateRoute(type: string, next:any) {
  if (userType) {
    if (type === userType) {
      iziToast.destroy()
      next()
    } else {
      if (userType === 'field') {
        if(store.state.user.subType === "ADMINISTRADOR"){
          next('dashboard-field')
        }else if(store.state.user.subType === "FINANZAS"){
          next('payments-field')
        }else{
          next('requests-field')
        }
      } else if(userType === 'admin'){
        if(store.state.user.subType === "ADMINISTRADOR"){
          next('dashboard-admin')
        }else if(store.state.user.subType === "FINANZAS"){
          next('dashboard-admin')
        }
      }
      iziToast.destroy()
    }
  } else {
    next('login')
  }
}

async function validateUserLoad(uid: string) {
  const adminRef = db.collection('admins').doc(uid)
  const usersRef = db.collection('users').doc(uid)
  await adminRef
    .get()
    .then(async function (doc) {
      const data = doc.data()
      if (doc.exists && data) {
        userType = 'admin'
        userSubType = data.type
        store.state.user.uid = uid
        store.state.user.type = userType
        store.state.user.subType = userSubType
        store.state.user.data = data
      } else {
        await usersRef
          .get()
          .then(async function (doc) {
            const data = doc.data()
            if (doc.exists && data) {
              iziToast.destroy()
              userType = 'field'
              userSubType = data.type
              store.state.user.uid = uid
              store.state.user.type = userType
              store.state.user.subType = userSubType
              store.state.user.data = data
            } else {
              if (
                this.$route.path !== '/login' &&
                this.$route.path !== '/signup' &&
                this.$route.path !== '/recoverpassword'
              ) {
                //iziToast.destroy()
                store.state.user.uid = ""
                store.state.user.type = ""
                store.state.user.subType = ""
                store.state.user.data = ""}
              // } else {
              //   console.log('No existe. Quedarse en la ruta actual')
              // }
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      }
    })
    .catch(function (error) {
      console.log(error)
    })

}

firebase.auth().onAuthStateChanged(async user =>{
  if(user){
    store.state.user.uid = user.uid
    if(Object.keys(store.state.user.data).length == 0){
      await validateUserLoad(user.uid)
    }
  }
  new Vue({
    router,
    store,
    vuetify,
    async created(){
      if (user) {
        store.state.user.uid = user.uid
        console.log(Object.keys(store.state.user.data).length)
        if (Object.keys(store.state.user.data).length == 0) {
          await validateUserLoad(user.uid)
        }
        if (this.$route.path === '/login') {
          this.$router.go(0)
        }

        try {
          const url = URL_CLOUD_FUNCTIONS + 'getAllPromotionCodes'
          const res = await Axios.get(url)
          store.state.promotionCodes = res.data.promotionCodes.data
        } catch (error) {
          console.log("Error al obtener cupones: "+error)
        }
        
      } else {
        store.state.user.uid = ""
        store.state.user.type = ""
        store.state.user.subType = ""
        store.state.user.data = {}

        router.push('/login')
      }
    },
    render: h => h(App)
  }).$mount("#app");
})

async function validateUser(uid:string, to:any, next:any) {
  const adminRef = db.collection('admins').doc(uid)
  const usersRef = db.collection('users').doc(uid)

  await adminRef
    .get()
    .then(async function (doc) {
      const data = doc.data()
      if (doc.exists && data) {
        // console.log('es admin. Router')
        userType = 'admin'
        userSubType = data.type
        store.state.user.uid = uid
        store.state.user.type = userType
        store.state.user.subType = userSubType
        store.state.user.data = data
        validateRoute(userType, next)
      } else {
        await usersRef
          .get()
          .then(async function (doc) {
            const data = doc.data()
            if (doc.exists && data) {
              iziToast.destroy()
              userType = 'field'
              userSubType = data.type
              store.state.user.uid = uid
              store.state.user.type = userType
              store.state.user.subType = userSubType
              store.state.user.data = data
              validateRoute(userType, next)
            } else {
              if (
                to.path !== '/login' &&
                to.path !== '/signup' &&
                to.path !== '/recoverpassword'
              ) {
                iziToast.destroy()
                store.state.user.uid = ""
                store.state.user.type = ""
                store.state.user.subType = ""
                store.state.user.data = ""

                next('login')
              } else {
                next()
              }
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      }
    })
    .catch(function (error) {
      console.log(error)
    })

}

router.beforeEach(async (to, from, next) => {
  const currentUser = firebase.auth().currentUser
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  let type = ""
  to.matched.some(record => {
    if (record.meta.type) {
      type = record.meta.type.toString()
    }
  })

  if (requiresAuth && !currentUser) {
    next('login')
  } else if (requiresAuth && currentUser) {
    if (userType) {
      validateRoute(type, next)
    } else {
      await validateUser(currentUser.uid, to, next)
    }
  } else if (!requiresAuth && currentUser) {
    if (userType) {
      validateRoute(type, next)
    } else {
      await validateUser(currentUser.uid, to, next)
    }
  } else {
    next()
  }
})
